import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './client.css';
import ConfirmModal from 'utils/ConfirmationModal';
import { toast } from 'react-toastify';
import TransactionHeader from './transactionPageComp/TransactionHeader';
import TransactionDetails from './transactionPageComp/TransactionDetails';
import TransactionList from './transactionPageComp/TransactionList';
import { useDeleteTransactionMutation } from 'actions/transactions/mutations';
import { useGetTransactionQuery } from 'actions/dossiers/queries';
// import bank from "../../image/Ellipse 19.png";
// import batim from '../../image/Ellipse 18.png';
// import wave from '../../image/Ellipse 17.png';
// import orangeMoney from '../../image/Ellipse 16.png';
// import { FaRegFolderOpen } from 'react-icons/fa';
import InterfaceMobileCaisse from './transactionPageComp/InterfaceMobileCaisse';
import { banques } from 'routes/navigation/sidebarDossierLinks';
import InterfaceMobileBanque from './transactionPageComp/InterfaceMobileBanque';
import ButtonTransaction from './transactionPageComp/ButtonTransaction';
import TransactionDetailsView from './transactionPageComp/TransactionDetailsView';
import InterfaceMobileWave from './transactionPageComp/InterfaceMobileWave';
import InterfaceMobileOM from './transactionPageComp/InterfaceMobileOM';
import ExportTransactionModal from './transactionPageComp/ExportTransactionModal';
import { Button } from 'react-bootstrap';
import { useGetComptePaiementQuery } from 'actions/compte_paiement/queries';
import TableLoader from 'components/Loader/TableLoader';


const TransactionPage = () => {
  const navigate = useNavigate();
  const { clientID: dossier_id } = useParams();
  const { data: getAllTransactions, isLoading, isFetching, refetch } = useGetTransactionQuery(
  { dossier_id }
);
  const { data: compte_paiement, refetch: refetchComptePaiement } = useGetComptePaiementQuery({ dossier_id });
  const [deleteTransaction] = useDeleteTransactionMutation();
  // States
  const [combinedData, setCombinedData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [paginationIndex, setPaginationIndex] = useState(0);
  const [currentTab, setCurrentTab] = useState('all');
  const [selectedRows, setSelectedRows] = useState([]);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [transactionToDelete, setTransactionToDelete] = useState(null);
  const [selectedPaymentSource, setSelectedPaymentSource] = useState(null);
  const [viewArchived, setViewArchived] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const nbrEntree = getAllTransactions?.transactions?.filter(t => t.type === 'entree')?.length || 0;
  const nbrSortie = getAllTransactions?.transactions?.filter(t => t.type === 'sortie')?.length || 0;

  // Refetch dès que le composant est monté (ex: retour depuis add-vente)
  useEffect(() => {
    refetch();
    refetchComptePaiement();
  }, []);

  const handleActionSelected = (action) => {
    if (action === 'archive') {
      setViewArchived(!viewArchived);
    } else {
      console.log(`Action selected: ${action}`);
    }
  };

  // Handlers
  const handlePaymentSourceClick = (source) => {
    setSelectedPaymentSource(source);
    setPaginationIndex(0); // Reset pagination when filter changes
  };

  const onEyeClick = (rowData) => {
    const parts = rowData.split('-');
    // Format: type-id-index
    const type = parts[0];
    const id = parts[1];

    navigate(`${type}/${id}/`);
  };

  const onDeleteClick = (transaction) => {
    setTransactionToDelete(transaction);
    setIsConfirmModalOpen(true);
  };

  const handleDeleteConfirmation = async () => {
    if (transactionToDelete) {
      const parts = transactionToDelete.split('-');
      // Format is: type-id-index (e.g., "entree-12-0")
      // parts[0] = type
      // parts[1] = id
      const type = parts[0];
      const id = parts[1];

      try {
        await deleteTransaction({ id: id, type: type }).unwrap();
        toast.success('Transaction supprimée avec succès');
        setIsConfirmModalOpen(false); // Close the modal upon success
        refetch();
      } catch (error) {
        toast.error(
          `Échec de la suppression de la transaction : ${error.message}`
        );
        setIsConfirmModalOpen(false); // Close the modal upon failure
        console.error('Requête échouée:', error);
      }
    }
  };

  const handlePageChange = (newIndex) => {
    setPaginationIndex(newIndex);
  };

  const handleRowSelect = (row, isSelect) => {
    const uniqueIdentifier = row.key;

    if (isSelect) {
      const existingRow = selectedRows.find(
        (selectedRow) => selectedRow.id === row.id
      );

      if (existingRow) {
        // If an existing row with the same id is found, use the unique key to differentiate
        setSelectedRows((prev) => [...prev, uniqueIdentifier]);
      } else {
        // If no existing row with the same id is found, it's safe to use the id directly
        setSelectedRows((prev) => [...prev, row.id]);
      }
    } else {
      // For deselection, remove the row by either its id or unique key
      setSelectedRows((prev) =>
        prev.filter(
          (selectedRow) =>
            selectedRow !== row.id && selectedRow !== uniqueIdentifier
        )
      );
    }
  };

  // Form handlers
  const handleFormDepense = () => {
    let currentPath = window.location.pathname;
    currentPath = currentPath.replace(/\/+$/, '');
    const pathSegments = currentPath.split('/');
    pathSegments.pop(); // This should now correctly remove the last word
    console.log(pathSegments);
    const newPath = [...pathSegments, `depenses`, `add-depense/`].join('/');
    navigate(newPath);
  };

  const handleFormVente = () => {
    let currentPath = window.location.pathname;
    currentPath = currentPath.replace(/\/+$/, '');
    const pathSegments = currentPath.split('/');
    pathSegments.pop();
    const newPath = [...pathSegments, `ventes`, `add-vente/`].join('/');
    navigate(newPath);
  };

  const handleFormCreances = () => {
    let currentPath = window.location.pathname;
    currentPath = currentPath.replace(/\/+$/, '');
    const pathSegments = currentPath.split('/');
    pathSegments.pop();
    const newPath = [...pathSegments,  `creances/`].join('/');
    navigate(newPath);
  };

  const handleFormDettes = () => {
    let currentPath = window.location.pathname;
    currentPath = currentPath.replace(/\/+$/, '');
    const pathSegments = currentPath.split('/');
    pathSegments.pop();
    const newPath = [...pathSegments, `dettes/`].join('/');
    navigate(newPath);
  };

  const [filteredList, setFilteredList] = useState([]); // Full filtered list for export
  const [advFilters, setAdvFilters] = useState({}); // Advanced filters state

  // Filter change handler
  const handleFilterChange = (newFilters) => {
    setAdvFilters(newFilters);
    setPaginationIndex(0);
  };

  // Data fetching and transformation
  useEffect(() => {
    if (!getAllTransactions?.transactions) {
      setCombinedData([]);
      setFilteredList([]);
      return;
    }

    let data = getAllTransactions.transactions.filter((item) => {
      // 1. Basic Filters (Payment Source & Archive)
      const matchesPaymentSource = selectedPaymentSource
        ? item.source_paiement === selectedPaymentSource
        : true;

      const matchesArchivalStatus = viewArchived
        ? item.archived
        : !item.archived;

      if (!matchesPaymentSource || !matchesArchivalStatus) return false;

      // 2. Advanced Filters
      const { names, dateStart, dateEnd, types, paymentModes, minAmount, maxAmount } = advFilters;

      if (names && names.length > 0) {
        const matchesName = names.some(name =>
          (item.client_nom === name) ||
          (item.client_details?.nom === name) ||
          (item.fournisseur_nom === name) ||
          (item.fournisseurs_details?.nom === name) ||
          (item.fournisseurs === name) ||
          (item.motif === name) ||
          (item.libelle === name)
        );
        if (!matchesName) return false;
      }

      // Date Range
      if (dateStart || dateEnd) {
        const itemDateStr = item.date || item.updated_at;
        if (!itemDateStr) return false; // If no date, exclude? Or include? Exclude seems safer.
        const itemDate = new Date(itemDateStr);

        if (dateStart) {
          const start = new Date(dateStart);
          // Zero out time for fair comparison if itemDate has time
          // Actually, if we want inclusive start:
          // itemDate >= start
          // But let's keep it simple: compare timestamps
          start.setHours(0, 0, 0, 0);
          if (itemDate < start) return false;
        }
        if (dateEnd) {
          const end = new Date(dateEnd);
          end.setHours(23, 59, 59, 999);
          if (itemDate > end) return false;
        }
      }

      // Type (Multi-select)
      if (types && types.length > 0) {
        if (!types.includes(item.type)) return false;
      }

      // Payment Mode (Multi-select)
      if (paymentModes && paymentModes.length > 0) {
        if (!paymentModes.includes(item.source_paiement)) return false;
      }

      let rawAmount = item.montant_total || item.montant;
      if (typeof rawAmount === 'string') {
        rawAmount = rawAmount.replace(/[^0-9.-]+/g, "");
      }
      const montant = parseFloat(rawAmount) || 0;

      // Ensure defaults are handled if min/max are undefined (though component initializes them)
      const min = minAmount !== undefined ? parseFloat(minAmount) : 0;
      const max = maxAmount !== undefined ? parseFloat(maxAmount) : Number.MAX_VALUE;

      if (montant < min || montant > max) return false;

      return true;
    });

    // 3. Tab Filtering (In/Out/Rapprochement)
    if (currentTab === 'out') {
      data = data.filter(item => item.type === 'sortie');
    } else if (currentTab === 'in') {
      data = data.filter(item => item.type === 'entree');
    } else if (currentTab === 'rapprochement') {
      data = data.filter(item => item.type === 'rapprochement');
    } else if (currentTab === 'creances') {
      data = data.filter(item => item.creance === true);
    } else if (currentTab === 'dettes') {
      data = data.filter(item => item.dette === true);
    }

    if (advFilters.sortBy) {
      data.sort((a, b) => {
        let valA, valB;

        if (advFilters.sortBy === 'names') {
          const getPartnerName = (item) => {
            return item.fournisseurs ||
              item.fournisseurs_details?.nom ||
              item.client_details?.nom ||
              item.client_nom ||
              item.fournisseur_nom ||
              item.libelle ||
              item.motif ||
              "";
          };
          valA = getPartnerName(a).toLowerCase();
          valB = getPartnerName(b).toLowerCase();
        } else {
          return 0;
        }

        if (valA < valB) return advFilters.sortOrder === 'asc' ? -1 : 1;
        if (valA > valB) return advFilters.sortOrder === 'asc' ? 1 : -1;
        return 0;
      });
    }

    // Add unique IDs for rendering
    data = data.map((item, index) => ({
      ...item,
      id: `${item.type}-${item.id}-${index}`, // Ensure unique ID
    }));

    // Update States
    setFilteredList(data);

    // Pagination
    const startIndex = paginationIndex * pageSize;
    const endIndex = startIndex + pageSize;
    setCombinedData(data.slice(startIndex, endIndex));

    console.log("Transactions: ",getAllTransactions)
  }, [
    getAllTransactions,
    currentTab,
    selectedPaymentSource,
    paginationIndex,
    pageSize,
    viewArchived,
    advFilters
  ]);

  // Styles (example)
  const ajoutFou = {
    fontFamily: 'Montserrat',
    fontWeight: '600',
    fontSize: '13px',
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [showDetailsTransaction, setShowDetailsTransaction] = useState(false);

  if (showDetailsTransaction && isMobile) {
    return (
      <TransactionDetailsView
        onBack={() => setShowDetailsTransaction(false)}
      />
    );
  }

  return (
    <div
      className="transaction-page"
      style={{
        backgroundColor: 'white',
        minHeight: '500px',
        borderRadius: '20px',
        padding: '15px',
      }}
    >
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onRequestClose={() => setIsConfirmModalOpen(false)}
        onConfirm={handleDeleteConfirmation}
        title="Confirmer la suppression"
        message="Êtes-vous sûr de vouloir supprimer cette transaction ? Cette action est irréversible."
      />

      <ExportTransactionModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        transactions={filteredList}
        dossierName={dossier_id}
      />

      <div className="d-flex justify-content-between align-items-center mb-3">
        <TransactionHeader
          transactionCount={filteredList?.length}
          viewArchived={viewArchived}
        />
        <Button variant="outline-success" onClick={() => setIsExportModalOpen(true)} style={{ borderColor: '#2c5f2d', color: '#2c5f2d' }}>
          <i className="bi bi-download me-2"></i> Exporter
        </Button>
      </div>



      <hr />
      {/** BOUTONS DE NAVIGATION EN MODE MOBILE */}
      <div className="banques-scroll mobile-only">
        {banques.map((item, index) => (
          <>
            <button
              key={index}
              className={`btn-banque ${activeIndex === index ? 'active' : ''}`}
              onClick={() => {
                setActiveIndex(index);
                navigate(item.route); // facultatif si tu veux juste changer le visuel
              }}
            >
              {item.image ? (
                <img src={item.image} alt={item.label} className="btn-icon" />
              ) : (
                <span className="btn-icon">{item.icon}</span>
              )}
              <span>{item.label}</span>
            </button>
          </>
        ))}
      </div>
      <div className="btntransact">
        <ButtonTransaction onClick={() => setShowDetailsTransaction(true)} />
      </div>
      {/* SI en mode mobile et un autre index est actif (1 ou 2) -> interface mobile */}
      {isMobile && activeIndex === 1 && <InterfaceMobileCaisse
        caisseData={getAllTransactions?.transactions_par_compte?.Caisse}
        transactions={getAllTransactions?.transactions?.filter(t => t.source_paiement === 'caisse') || []}
        nbrEntree={nbrEntree}
        nbrSortie={nbrSortie}
      />}
      {isMobile && activeIndex === 2 && <InterfaceMobileBanque
        banqueData={getAllTransactions?.transactions_par_compte?.Banque}
        transactions={getAllTransactions?.transactions?.filter(t => t.source_paiement === 'banque') || []}
        nbrEntree={nbrEntree}
        nbrSortie={nbrSortie}
      />}
      {isMobile && activeIndex === 3 && <InterfaceMobileWave
        waveData={getAllTransactions?.transactions_par_compte?.Wave}
        transactions={getAllTransactions?.transactions?.filter(t => t.source_paiement === 'wave') || []}
        nbrEntree={nbrEntree}
        nbrSortie={nbrSortie}
      />}
      {isMobile && activeIndex === 4 && <InterfaceMobileOM
        omData={getAllTransactions?.transactions_par_compte?.OrangeMoney}
        transactions={getAllTransactions?.transactions?.filter(t => t.source_paiement === 'orange_money') || []}
        nbrEntree={nbrEntree}
        nbrSortie={nbrSortie}
      />}


      {(activeIndex === 0 || !isMobile) && (
        isLoading || (isFetching && !getAllTransactions) ? (
          <div style={{ background: '#ffffff', borderRadius: '14px', padding: '30px', border: '1px solid #e2eced' }}>
            <TableLoader
              message="Chargement des transactions..."
              subMessage="Récupération des entrées, sorties et soldes par compte"
              minHeight="350px"
            />
          </div>
        ) : (
          <>
            <TransactionDetails
              soldeTotal={getAllTransactions?.solde_total_reel || 0}
              nbrTransactions={getAllTransactions?.transactions?.length || 0}
              comptePaiement={compte_paiement?.data || []}
              nbrEntree={nbrEntree}
              nbrSortie={nbrSortie}
              onCardClick={handlePaymentSourceClick}
            />
            <TransactionList
              combinedData={combinedData || []}
              allData={getAllTransactions?.transactions} // Pass full data
              filters={advFilters} // Pass filters
              onFilterChange={handleFilterChange} // Pass handler for filters & sort
              paginationIndex={paginationIndex}
              setPaginationIndex={handlePageChange}
              dataLength={filteredList?.length || 0}
              pageSize={pageSize}
              setPageSize={setPageSize}
              selectedRows={selectedRows}
              handleRowSelect={handleRowSelect}
              onEyeClick={onEyeClick}
              onDeleteClick={onDeleteClick}
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
              handleFormDepense={handleFormDepense}
              handleFormVente={handleFormVente}
              handleFormCreances={handleFormCreances}
              handleFormDettes={handleFormDettes}
              ajoutFou={ajoutFou}
              viewArchived={viewArchived}
              onActionSelected={handleActionSelected}
              isMobile={isMobile}
            />
          </>
        )
      )}
    </div>
  );
};

export default TransactionPage;